import { useMemo } from "react";
import { BotTemplateData, QueryBotType } from "@shared/types";
import { useHistory, useRouteMatch } from "react-router-dom";
import { getBotFormRoute } from "utils/routes.tsx";
import { BotFormType } from "@shared/features/bots/BotForm/common/types.ts";
import { BASE_PUBLIC_EDIT_BOT_PATH } from "common/constants.ts";
import { QUERY_BOT_TYPE_TO_BOT_TYPE } from "@shared/common/constants.ts";
import useQuery from "utils/hooks/useQuery.ts";
import { APPLIED_BACKTESTING_QUERY_PARAM } from "features/bots/common/constants.ts";

interface useQueryPublicBotsProps {
  filteredBots?: BotTemplateData[];
}

const useQueryPublicBots = ({ filteredBots }: useQueryPublicBotsProps) => {
  const history = useHistory();
  const query = useQuery();
  const match = useRouteMatch(BASE_PUBLIC_EDIT_BOT_PATH);
  const { botType: queryBotType, botUUID } = (match?.params || {}) as {
    botType?: QueryBotType;
    botUUID?: string;
  };
  const isBacktestingApplied = !!query.get(APPLIED_BACKTESTING_QUERY_PARAM);

  const appliedPublicBot = useMemo(() => {
    if (!botUUID) return;
    return filteredBots?.find((publicBot) => publicBot.uuid === botUUID);
  }, [filteredBots, botUUID]);

  const publicBots = useMemo(() => {
    return filteredBots?.filter(
      (publicBot) => publicBot.uuid !== appliedPublicBot?.uuid
    );
  }, [filteredBots, appliedPublicBot]);

  const unapplyConfiguration = () => {
    if (queryBotType) {
      history.push(
        getBotFormRoute(
          QUERY_BOT_TYPE_TO_BOT_TYPE[queryBotType],
          BotFormType.CREATE
        )
      );
    }
  };

  const showDivider =
    !!appliedPublicBot && !!publicBots?.length && !isBacktestingApplied;

  return {
    publicBots,
    appliedPublicBot,
    unapplyConfiguration,
    showDivider,
    isBacktestingApplied,
  };
};

export default useQueryPublicBots;
